import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

/** Same shape as mot-website-client CmsStaticVariable. */
export interface CmsStaticVariable {
  key: string;
  name: string;
  value: string;
}

/**
 * CMS static variables API (contact block content), same endpoint as mot-website-client _CmsApiService.fetchStaticVariables.
 */
@Injectable({ providedIn: 'root' })
export class WebsiteCmsStaticVariablesService {
  private staticVariablesCache$: Observable<CmsStaticVariable[]> | null = null;

  constructor(private readonly http: HttpClient) {}

  fetchStaticVariables(): Observable<CmsStaticVariable[]> {
    if (this.staticVariablesCache$) {
      return this.staticVariablesCache$;
    }
    const base = environment.bo_be_service_url.replace(/\/+$/, '');
    const url = `${base}/cms-static-variables`;
    this.staticVariablesCache$ = this.http.get<CmsStaticVariable[]>(url).pipe(
      catchError((error) => {
        console.error('WebsiteCmsStaticVariablesService: API error', error);
        return of([]);
      }),
      shareReplay(1)
    );
    return this.staticVariablesCache$;
  }
}
